import { render } from "./ResultsMultipleChoiceQuestion.vue?vue&type=template&id=0369dbc6"
import script from "./ResultsMultipleChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./ResultsMultipleChoiceQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__